import {
  CommonMetadata,
  CommonMetadataFetchArgs,
  getCommonMetadata,
} from '../assets/ts/data/common-metadata'
import useServerData from './use-server-data'

function useCommonMetadata(
  fetchArgs: CommonMetadataFetchArgs,
  waitOnParentDependency = false
) {
  const {
    data: commonMetadata,
    error: commonMetadataError,
    fetchData: fetchCommonMetdata,
    isLoading: commonMetadataIsLoading,
  } = useServerData<CommonMetadata, CommonMetadataFetchArgs>(
    getCommonMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  return {
    commonMetadata,
    commonMetadataError,
    commonMetadataIsLoading,
    fetchCommonMetdata,
  }
}

export default useCommonMetadata
